﻿import { observable, makeObservable, action, computed, autorun } from "mobx";
import { IExternalLayerSettings } from "../models/IExternalLayerSettings";
import { IExternalLayersState } from "../models/ChartModels";
import { IStateStore, StateStore } from "./StateStore";
import { ExternalChartLayer } from "../components/externalLayers/LayerInterfaces";

export class ExternalLayersStore extends StateStore<IExternalLayersState> implements IExternalLayersState, IStateStore<IExternalLayersState> {

    public selectedLayerId: number = -1;
    public layers: ExternalChartLayer[] = [];
    public enableLayerAdmin: boolean = false;

    constructor(private externalLayerSettings: IExternalLayerSettings) {
        super()
        makeObservable(this, {
            enableLayerAdmin: observable,
            layers: observable,
            selectedLayerId: observable,
            addLayer: action.bound,
            updateLayer: action.bound,
            removeLayer: action.bound,
        });

        this.init();
    }

    public init() {
        this.enableLayerAdmin = this.externalLayerSettings.enableLayerAdmin;
        this.externalLayerSettings.getLayers()
            .then(res => {
                this.setState({ layers: res });
            });
    } 

    public async addLayer(layer: ExternalChartLayer) {
        if (!this.enableLayerAdmin) {
            console.error("Not authorized");
            return;
        }

        await this.externalLayerSettings.addLayer!(layer);
        this.setState({ layers: await this.externalLayerSettings.getLayers() });
    }

    public async updateLayer(layer: ExternalChartLayer) {
        if (!this.enableLayerAdmin) {
            console.error("Not authorized");
            return;
        }

        await this.externalLayerSettings.updateLayer!(layer);
        this.setState({ layers: await this.externalLayerSettings.getLayers() });
    }

    public async removeLayer(id: number) {
        if (!this.enableLayerAdmin) {
            console.error("Not authorized");
            return;
        }

        await this.externalLayerSettings.removeLayer!(id);
        this.setState({ layers: await this.externalLayerSettings.getLayers() });
    }

    public get getState(): IExternalLayersState {
        const { layers, selectedLayerId, enableLayerAdmin } = this;
        return { layers: layers.slice(), selectedLayerId, enableLayerAdmin };
    }

    public setState(state: Partial<IExternalLayersState>) {
        state = { ...state };

        if (state.layers) {
            this.layers = state.layers?.slice();
            delete state.layers;
        }

        super.setState(state);
    }
}